import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import GlobalSlider from "../../GenericComponents/GlobalSlider";
import CustomRadioButton from "../../GenericComponents/CustomRadioButton";
import styles from "../style";

class AudioRecordingCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      audioSettings,
      defaultSettings,
      handleSliderValues,
      handleChanges,
    } = this.props;
    return (
      <div>
        <div className={css(styles.formGroupStyles)}>
          <label style={{fontSize: "14px", textTransform: "capitalize",}}>
            Enable audio recording
          </label>
          <CustomRadioButton
            name={"enableAudioRecording"}
            type={"switch"}
            inline={true}
            label={""}
            checked={audioSettings.enableAudioRecording}
            action={handleChanges}
          />
        </div>
        {audioSettings.enableAudioRecording && (
          <div style={{ paddingLeft: "10px" }}>
            <label
              className={css(styles.valueLabels)}
            >
              set audio recording duration for during and after an event ({defaultSettings.AUDIO_RECORD_DURATION.minValue} -{" "}
              {defaultSettings.AUDIO_RECORD_DURATION.maxValue}{" "}
              {defaultSettings.AUDIO_RECORD_DURATION.unit})
            </label>
            <GlobalSlider
              name={"audioRecordingDuration"}
              min={parseInt(defaultSettings.AUDIO_RECORD_DURATION.minValue)}
              max={parseInt(defaultSettings.AUDIO_RECORD_DURATION.maxValue)}
              value={audioSettings.audioRecordingDuration}
              //onChangeStart={this.handleChangeStart}
              action={handleSliderValues}
              //onChangeComplete={this.handleChangeComplete}
            />
          </div>
        )}
      </div>
    );
  }
}

export default AudioRecordingCard;

const style = StyleSheet.create({
  title: {
    fontSize: "18px",
    color: "white",
  },
  subTitle: {
    fontSize: "12px",
    color: "white",
  },
  headerStyle: {
    background: "#0d6cbf",
    margin: "-1px",
  },
  footerStyles: {
    display: "block !important",
    textAlign: "center",
  },
});
